import React from 'react';
import styles from './PlanTermsStep.module.css';

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={styles.featureTileCheck}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

const BOOK_A_CALL_URL = 'https://calendly.com/kamrans1101/hooptie-demo';

const ValueSidebar = () => (
  <div className={styles.rightCol}>
    <div className={styles.sidebarCard}>
      <div className={styles.sidebarCardTitle}>
        <span className={styles.sidebarCardIcon}>$</span>
        Why It Pays For Itself
      </div>
      <div className={styles.sidebarCardBody}>
        <strong>Flip 1 car, pay for 3 months</strong>
        <p className={styles.sidebarCardSubtext}>Most dealers recover their subscription in 1–2 flips.</p>
      </div>
    </div>

    <div className={styles.sidebarCard}>
      <div className={styles.sidebarCardTitleTrust}>
        Avoid Expensive Sourcing Mistakes
      </div>
      <p className={styles.sidebarCardSubtext} style={{ marginBottom: 14 }}>
        One bad buy can wipe out months of profit. Hooptie flags weak demand, overpriced comps, and slow-moving inventory before you commit.
      </p>
      <ul className={styles.sidebarList}>
        <li><CheckIcon /> Spot weak demand before you buy</li>
        <li><CheckIcon /> Avoid overpriced auction units</li>
        <li><CheckIcon /> Protect your turn time & cash flow</li>
        <li><CheckIcon /> Need help deciding? <a href={BOOK_A_CALL_URL} target="_blank" rel="noopener noreferrer" className={styles.sidebarLink}>Book a 15-min call</a></li>
      </ul>
    </div>
  </div>
);

export default ValueSidebar;
